/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { DelegateOperations } from '../model/delegateOperations';
import { IvCertGenericResponseBoolean } from '../model/ivCertGenericResponseBoolean';
import { IvCertGenericResponseDelegateOperations } from '../model/ivCertGenericResponseDelegateOperations';
import { IvCertGenericResponseListCargoL } from '../model/ivCertGenericResponseListCargoL';
import { IvCertGenericResponseListHistoryAuditCircuit } from '../model/ivCertGenericResponseListHistoryAuditCircuit';
import { IvCertGenericResponseListMetadataKeyOperationF } from '../model/ivCertGenericResponseListMetadataKeyOperationF';
import { IvCertGenericResponseListOperationP } from '../model/ivCertGenericResponseListOperationP';
import { IvCertGenericResponseListOperationStatus } from '../model/ivCertGenericResponseListOperationStatus';
import { IvCertGenericResponseListOperationType } from '../model/ivCertGenericResponseListOperationType';
import { IvCertGenericResponseListReassignOperations } from '../model/ivCertGenericResponseListReassignOperations';
import { IvCertGenericResponseListString } from '../model/ivCertGenericResponseListString';
import { IvCertGenericResponseListWidget } from '../model/ivCertGenericResponseListWidget';
import { IvCertGenericResponseMassiveSignError } from '../model/ivCertGenericResponseMassiveSignError';
import { IvCertGenericResponseOperationDetailR } from '../model/ivCertGenericResponseOperationDetailR';
import { IvCertGenericResponseParseResponse } from '../model/ivCertGenericResponseParseResponse';
import { IvCertGenericResponseString } from '../model/ivCertGenericResponseString';
import { IvGenericRestResponseBoolean } from '../model/ivGenericRestResponseBoolean';
import { IvGenericRestResponseString } from '../model/ivGenericRestResponseString';
import { MetadataOperation } from '../model/metadataOperation';
import { PageResultDelegateOperations } from '../model/pageResultDelegateOperations';
import { ParseCertified } from '../model/parseCertified';
import { ReassignOperations } from '../model/reassignOperations';
import { MassiveSignature } from '../model/massiveSignature';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { IvCertGenericResponseListAuthPreference } from '../model/ivCertGenericResponseListAuthPreference';
import { IvCertGenericResponseListWidgetParams } from '../model/ivCertGenericResponseListWidgetParams';
import { Environment } from '../../models/environment';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { IvGenericRestResponseListOperationEvent } from "../model/ivGenericRestResponseListOperationEvent";
import { EnvironmentService } from './environment.service';

@Injectable()
export class OperationService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param idDelegation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationDeleteDelegationsOperations(idDelegation: Array<number>, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationDeleteDelegationsOperations(idDelegation: Array<number>, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationDeleteDelegationsOperations(idDelegation: Array<number>, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationDeleteDelegationsOperations(idDelegation: Array<number>, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idDelegation === null || idDelegation === undefined) {
            throw new Error('Required parameter idDelegation was null or undefined when calling operationDeleteDelegationsOperations.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationDeleteDelegationsOperations.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idDelegation) {
            idDelegation.forEach((element) => {
                queryParameters = queryParameters.append('idDelegation', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/DelegationsOperations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param idOperation
     * @param externalIdOperation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetAuditOperation(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListHistoryAuditCircuit>;
    public operationGetAuditOperation(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListHistoryAuditCircuit>>;
    public operationGetAuditOperation(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListHistoryAuditCircuit>>;
    public operationGetAuditOperation(authorization: string, idOperation?: string, externalIdOperation?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetAuditOperation.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (externalIdOperation !== undefined && externalIdOperation !== null) {
            queryParameters = queryParameters.set('externalIdOperation', <any>externalIdOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListHistoryAuditCircuit>(`${this.basePath}/api/${this.apiVersion}/Operation/AuditOperation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las incidencias generadas en un proceso de firma masiva
     *
     * @param idProcess Identificador interno del proceso de firma masiva
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetCheckProcessMassiveSignature(idProcess: string, authorization: string, idDocument?: string, idOperation?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseMassiveSignError>;
    public operationGetCheckProcessMassiveSignature(idProcess: string, authorization: string, idDocument?: string, idOperation?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseMassiveSignError>>;
    public operationGetCheckProcessMassiveSignature(idProcess: string, authorization: string, idDocument?: string, idOperation?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseMassiveSignError>>;
    public operationGetCheckProcessMassiveSignature(idProcess: string, authorization: string, idDocument?: string, idOperation?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idProcess === null || idProcess === undefined) {
            throw new Error('Required parameter idProcess was null or undefined when calling operationGetCheckProcessMassiveSignature.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetCheckProcessMassiveSignature.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idProcess !== undefined && idProcess !== null) {
            queryParameters = queryParameters.set('idProcess', <any>idProcess);
        }

        if (idDocument !== undefined && idDocument !== null) {
            queryParameters = queryParameters.set('idDocument', <any>idDocument);
        }

        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseMassiveSignError>(`${this.basePath}/api/${this.apiVersion}/Operation/CheckProcessMassiveSignature`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Envío de los metadatos necesarios según el tipo de operación
     *
     * @param typeOperation
     * @param idOperation
     * @param authorization The authorization token
     * @param appId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetConfigMetadaOperation(typeOperation: string, idOperation: string, authorization: string, appId?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListMetadataKeyOperationF>;
    public operationGetConfigMetadaOperation(typeOperation: string, idOperation: string, authorization: string, appId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListMetadataKeyOperationF>>;
    public operationGetConfigMetadaOperation(typeOperation: string, idOperation: string, authorization: string, appId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListMetadataKeyOperationF>>;
    public operationGetConfigMetadaOperation(typeOperation: string, idOperation: string, authorization: string, appId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (typeOperation === null || typeOperation === undefined) {
            throw new Error('Required parameter typeOperation was null or undefined when calling operationGetConfigMetadaOperation.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetConfigMetadaOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetConfigMetadaOperation.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeOperation !== undefined && typeOperation !== null) {
            queryParameters = queryParameters.set('typeOperation', <any>typeOperation);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListMetadataKeyOperationF>(`${this.basePath}/api/${this.apiVersion}/Operation/ConfigMetadataOperation`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param top The max number of records. (e.g. $top&#x3D;10)
     * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
     * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
     * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
     * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
     * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetDelegationsOperations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<PageResultDelegateOperations>;
    public operationGetDelegationsOperations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageResultDelegateOperations>>;
    public operationGetDelegationsOperations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageResultDelegateOperations>>;
    public operationGetDelegationsOperations(authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetDelegationsOperations.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (top !== undefined && top !== null) {
            queryParameters = queryParameters.set('$top', <any>top);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('$skip', <any>skip);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>filter);
        }
        if (select !== undefined && select !== null) {
            queryParameters = queryParameters.set('$select', <any>select);
        }
        if (inlinecount !== undefined && inlinecount !== null) {
            queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
        }
        if (orderby !== undefined && orderby !== null) {
            queryParameters = queryParameters.set('$orderby', <any>orderby);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<PageResultDelegateOperations>(`${this.basePath}/api/${this.apiVersion}/Operation/DelegationsOperations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetDelegationsOperationsPositionsUser(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCargoL>;
    public operationGetDelegationsOperationsPositionsUser(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCargoL>>;
    public operationGetDelegationsOperationsPositionsUser(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCargoL>>;
    public operationGetDelegationsOperationsPositionsUser(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetDelegationsOperationsPositionsUser.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListCargoL>(`${this.basePath}/api/${this.apiVersion}/Operation/DelegationsOperationsPositionsUser`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return if exists simultaneous operation (if not exists insert in table)
     *
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async operationGetExistSimultaneousOperations(idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseString>;
    async operationGetExistSimultaneousOperations(idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseString>>;
    async operationGetExistSimultaneousOperations(idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseString>>;
    async operationGetExistSimultaneousOperations(idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetExistSimultaneousOperations.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetExistSimultaneousOperations.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseString>(`${this.basePath}/api/${this.apiVersion}/Operation/GetExistSimultaneousOperations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Obtiene la lista de los estados de las operaciones
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetListStatusOperation(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOperationStatus>;
    public operationGetListStatusOperation(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOperationStatus>>;
    public operationGetListStatusOperation(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOperationStatus>>;
    public operationGetListStatusOperation(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetListStatusOperation.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOperationStatus>(`${this.basePath}/api/${this.apiVersion}/Operation/ListStatusOperation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de tipos de operaciones
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetListTypeOperation(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOperationType>;
    public operationGetListTypeOperation(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOperationType>>;
    public operationGetListTypeOperation(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOperationType>>;
    public operationGetListTypeOperation(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetListTypeOperation.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOperationType>(`${this.basePath}/api/${this.apiVersion}/Operation/ListTypeOperation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * Get next active operation from user, the actual operation is closed
     *
     * @param idOperation Closed operation identifier
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetNextOperationClosed(idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseString>;
    public operationGetNextOperationClosed(idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseString>>;
    public operationGetNextOperationClosed(idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseString>>;
    public operationGetNextOperationClosed(idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetNextOperationClosed.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetNextOperationClosed.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvGenericRestResponseString>(`${this.basePath}/api/${this.apiVersion}/Operation/NextOperationClosed`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Recupera el detalle de la operación
     *
     * @param idOperation Identificador de la operación
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async operationGetOperationDetail(idOperation: string, authorization: string, signerGuid?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseOperationDetailR>;
    async operationGetOperationDetail(idOperation: string, authorization: string, signerGuid?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseOperationDetailR>>;
    async operationGetOperationDetail(idOperation: string, authorization: string, signerGuid?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseOperationDetailR>>;
    async operationGetOperationDetail(idOperation: string, authorization: string, signerGuid?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationDetail.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationDetail.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (signerGuid !== undefined && signerGuid !== null) {
            queryParameters = queryParameters.set('signerGuid', <any>signerGuid);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvCertGenericResponseOperationDetailR>(`${this.basePath}/api/${this.apiVersion}/Operation/GetOperationDetail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Devolver la configuración de la marca gáfica avanzada para una organización
     *
     * @param idOperation Identificador interno de la operación
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationGraficConfig(idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseString>;
    public operationGetOperationGraficConfig(idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseString>>;
    public operationGetOperationGraficConfig(idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseString>>;
    public operationGetOperationGraficConfig(idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationGraficConfig.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationGraficConfig.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseString>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationGraficConfig`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get if the operation is for a external user
     *
     * @param idOperation Operation identifier
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async operationGetOperationIsExternal(idOperation: string, authorization: string, signerGuid?: string, observe?: 'body', reportProgress?: boolean): Promise<IvGenericRestResponseBoolean>;
    async operationGetOperationIsExternal(idOperation: string, authorization: string, signerGuid?: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvGenericRestResponseBoolean>>;
    async operationGetOperationIsExternal(idOperation: string, authorization: string, signerGuid?: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvGenericRestResponseBoolean>>;
    async operationGetOperationIsExternal(idOperation: string, authorization: string, signerGuid?: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationIsExternal.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationIsExternal.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (signerGuid !== undefined && signerGuid !== null) {
            queryParameters = queryParameters.set('signerGuid', <any>signerGuid);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationIsExternal`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * Reenvía las notificaciones a la operación enviada
     *
     * @param idOperation Identificador interno de la operación
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationNotificationForwarding(idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationGetOperationNotificationForwarding(idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationGetOperationNotificationForwarding(idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationGetOperationNotificationForwarding(idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationNotificationForwarding.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationNotificationForwarding.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationNotificationForwarding`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reenvía la notificación de una operación al correo insertado. Sólo los administradores de la organización podrán utilizar la utilidad.
     *
     * @param idOperation Identificador interno de la operación
     * @param email Correo del usuario
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationNotificationForwardingAdmin(idOperation: string, email: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationGetOperationNotificationForwardingAdmin(idOperation: string, email: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationGetOperationNotificationForwardingAdmin(idOperation: string, email: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationGetOperationNotificationForwardingAdmin(idOperation: string, email: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationNotificationForwardingAdmin.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling operationGetOperationNotificationForwardingAdmin.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationNotificationForwardingAdmin.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationNotificationForwardingAdmin`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Recupera todas las operaciones de un circuito
     *
     * @param idCircuit Identificador del circuito
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationsCircuit(idCircuit: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOperationP>;
    public operationGetOperationsCircuit(idCircuit: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOperationP>>;
    public operationGetOperationsCircuit(idCircuit: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOperationP>>;
    public operationGetOperationsCircuit(idCircuit: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling operationGetOperationsCircuit.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationsCircuit.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListOperationP>(`${this.basePath}/api/${this.apiVersion}/Operation/GetOperationsCircuit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOperation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationEvents(idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListOperationEvent>;
    public operationGetOperationEvents(idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListOperationEvent>>;
    public operationGetOperationEvents(idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListOperationEvent>>;
    public operationGetOperationEvents(idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetOperationEvents.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationEvents.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvGenericRestResponseListOperationEvent>(`${this.basePath}/api/${this.apiVersion}/Operation/GetOperationEvents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Envía el SMS en las tareas de RVDOTP y OTP
     *
     * @param idOperation Identificador de la operación
     * @param appId Identificador de la personalización
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async operationGetSendOTP(idOperation: string, appId: string, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<any>;
    async operationGetSendOTP(idOperation: string, appId: string, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<any>>;
    async operationGetSendOTP(idOperation: string, appId: string, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<any>>;
    async operationGetSendOTP(idOperation: string, appId: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetSendOTP.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling operationGetSendOTP.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetSendOTP.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/Operation/SendOTP`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
    * Get all widgets for type operation, customization and organization
    *
    * @param typeOperation Identificador tipo de operación
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public operationGetWidgets(typeOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListWidget>;
    public operationGetWidgets(typeOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListWidget>>;
    public operationGetWidgets(typeOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListWidget>>;
    public operationGetWidgets(typeOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (typeOperation === null || typeOperation === undefined) {
            throw new Error('Required parameter typeOperation was null or undefined when calling operationGetWidgets.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetWidgets.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeOperation !== undefined && typeOperation !== null) {
            queryParameters = queryParameters.set('typeOperation', <any>typeOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListWidget>(`${this.basePath}/api/${this.apiVersion}/Operation/GetWidgets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     *
     *
     * @param delegateOperations
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostDelegationsOperations(delegateOperations: DelegateOperations, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseDelegateOperations>;
    public operationPostDelegationsOperations(delegateOperations: DelegateOperations, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseDelegateOperations>>;
    public operationPostDelegationsOperations(delegateOperations: DelegateOperations, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseDelegateOperations>>;
    public operationPostDelegationsOperations(delegateOperations: DelegateOperations, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (delegateOperations === null || delegateOperations === undefined) {
            throw new Error('Required parameter delegateOperations was null or undefined when calling operationPostDelegationsOperations.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostDelegationsOperations.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseDelegateOperations>(`${this.basePath}/api/${this.apiVersion}/Operation/DelegationsOperations`,
            delegateOperations,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param massiveSignature
     * @param operationType
     * @param authorization The authorization token
     * @param idCert
     * @param passCert
     * @param tokenIvsign
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostMassiveSignature(massiveSignature: MassiveSignature, operationType: string, authorization: string, idCert?: string, passCert?: string, tokenIvsign?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseString>;
    public operationPostMassiveSignature(massiveSignature: MassiveSignature, operationType: string, authorization: string, idCert?: string, passCert?: string, tokenIvsign?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseString>>;
    public operationPostMassiveSignature(massiveSignature: MassiveSignature, operationType: string, authorization: string, idCert?: string, passCert?: string, tokenIvsign?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseString>>;
    public operationPostMassiveSignature(massiveSignature: MassiveSignature, operationType: string, authorization: string, idCert?: string, passCert?: string, tokenIvsign?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (massiveSignature === null || massiveSignature === undefined) {
            throw new Error('Required parameter massiveSignature was null or undefined when calling operationPostMassiveSignature.');
        }

        if (operationType === null || operationType === undefined) {
            throw new Error('Required parameter operationType was null or undefined when calling operationPostMassiveSignature.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostMassiveSignature.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (operationType !== undefined && operationType !== null) {
            queryParameters = queryParameters.set('operationType', <any>operationType);
        }
        if (idCert !== undefined && idCert !== null) {
            queryParameters = queryParameters.set('idCert', <any>idCert);
        }
        if (passCert !== undefined && passCert !== null) {
            queryParameters = queryParameters.set('passCert', <any>passCert);
        }
        if (tokenIvsign !== undefined && tokenIvsign !== null) {
            queryParameters = queryParameters.set('tokenIvsign', <any>tokenIvsign);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseString>(`${this.basePath}/api/${this.apiVersion}/Operation/MassiveSignature`,
            massiveSignature,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Llamada para hacer de puente entre front y el api de ivnosys, para obtener el certificado
     *
     * @param b64pk Identificador ddel certificado
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostParseCertificate(b64pk: ParseCertified, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseParseResponse>;
    public operationPostParseCertificate(b64pk: ParseCertified, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseParseResponse>>;
    public operationPostParseCertificate(b64pk: ParseCertified, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseParseResponse>>;
    public operationPostParseCertificate(b64pk: ParseCertified, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (b64pk === null || b64pk === undefined) {
            throw new Error('Required parameter b64pk was null or undefined when calling operationPostParseCertificate.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostParseCertificate.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseParseResponse>(`${this.basePath}/api/${this.apiVersion}/Operation/ParseCertificate`,
            b64pk,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param reassignOperations
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostReassignOperations(reassignOperations: Array<ReassignOperations>, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListReassignOperations>;
    public operationPostReassignOperations(reassignOperations: Array<ReassignOperations>, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListReassignOperations>>;
    public operationPostReassignOperations(reassignOperations: Array<ReassignOperations>, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListReassignOperations>>;
    public operationPostReassignOperations(reassignOperations: Array<ReassignOperations>, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (reassignOperations === null || reassignOperations === undefined) {
            throw new Error('Required parameter reassignOperations was null or undefined when calling operationPostReassignOperations.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostReassignOperations.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseListReassignOperations>(`${this.basePath}/api/${this.apiVersion}/Operation/ReassignOperations`,
            reassignOperations,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reenvía las notificaciones a la operación enviada (IVDESK)
     *
     * @param idOperations Identificador interno de la operación
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostUrlSignMultipleOperation(idOperations: Array<string>, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseString>;
    public operationPostUrlSignMultipleOperation(idOperations: Array<string>, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseString>>;
    public operationPostUrlSignMultipleOperation(idOperations: Array<string>, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseString>>;
    public operationPostUrlSignMultipleOperation(idOperations: Array<string>, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperations === null || idOperations === undefined) {
            throw new Error('Required parameter idOperations was null or undefined when calling operationPostUrlSignMultipleOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostUrlSignMultipleOperation.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvCertGenericResponseString>(`${this.basePath}/api/${this.apiVersion}/Operation/UrlSignMultipleOperation`,
            idOperations,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param delegationOperation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPutDelegationsOperations(delegationOperation: DelegateOperations, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseDelegateOperations>;
    public operationPutDelegationsOperations(delegationOperation: DelegateOperations, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseDelegateOperations>>;
    public operationPutDelegationsOperations(delegationOperation: DelegateOperations, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseDelegateOperations>>;
    public operationPutDelegationsOperations(delegationOperation: DelegateOperations, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (delegationOperation === null || delegationOperation === undefined) {
            throw new Error('Required parameter delegationOperation was null or undefined when calling operationPutDelegationsOperations.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPutDelegationsOperations.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseDelegateOperations>(`${this.basePath}/api/${this.apiVersion}/Operation/DelegationsOperations`,
            delegationOperation,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish operation circuit and get next operation
     *
     * @param idOperation Operation identifier internal o external
     * @param opMetadata List operation metadata
     * @param appId
     * @param Authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPutFinishOperation(idOperation: string, opMetadata: Array<MetadataOperation>, appId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListString>;
    public operationPutFinishOperation(idOperation: string, opMetadata: Array<MetadataOperation>, appId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListString>>;
    public operationPutFinishOperation(idOperation: string, opMetadata: Array<MetadataOperation>, appId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListString>>;
    public operationPutFinishOperation(idOperation: string, opMetadata: Array<MetadataOperation>, appId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationPutFinishOperation.');
        }

        if (opMetadata === null || opMetadata === undefined) {
            throw new Error('Required parameter opMetadata was null or undefined when calling operationPutFinishOperation.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling operationPutFinishOperation.');
        }

        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling operationPutFinishOperation.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }

        let headers = this.defaultHeaders;
        if (Authorization !== undefined && Authorization !== null) {
            headers = headers.set('Authorization', String(Authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseListString>(`${this.basePath}/api/v3/Operation/FinishOperation`,
            opMetadata,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update operation email
     *
     * @param email Email
     * @param keepDate Flag to keep the date
     * @param authorization The authorization token
     * @param idOperation Internal identifier operation
     * @param externalIdOperation External identifier operation
     * @param idCircuit Internal or external identifier circuit
     * @param phone New phone
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPutModifyOperation(email: string, keepDate: boolean, authorization: string, idOperation?: string, externalIdOperation?: string, idCircuit?: string, phone?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationPutModifyOperation(email: string, keepDate: boolean, authorization: string, idOperation?: string, externalIdOperation?: string, idCircuit?: string, phone?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationPutModifyOperation(email: string, keepDate: boolean, authorization: string, idOperation?: string, externalIdOperation?: string, idCircuit?: string, phone?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationPutModifyOperation(email: string, keepDate: boolean, authorization: string, idOperation?: string, externalIdOperation?: string, idCircuit?: string, phone?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling operationPutModifyOperation.');
        }

        if (keepDate === null || keepDate === undefined) {
            throw new Error('Required parameter keepDate was null or undefined when calling operationPutModifyOperation.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPutModifyOperation.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (keepDate !== undefined && keepDate !== null) {
            queryParameters = queryParameters.set('keepDate', <any>keepDate);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (externalIdOperation !== undefined && externalIdOperation !== null) {
            queryParameters = queryParameters.set('externalIdOperation', <any>externalIdOperation);
        }
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (phone !== undefined && phone !== null) {
            queryParameters = queryParameters.set('phone', <any>phone);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/GetModifyOperation`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     * Actualiza el último acceso del usuario a la operación
     *
     * @param idOperation Identificador de la operación
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    async operationPutUpdateFirstAccess(idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Promise<IvCertGenericResponseBoolean>;
    async operationPutUpdateFirstAccess(idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<IvCertGenericResponseBoolean>>;
    async operationPutUpdateFirstAccess(idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<IvCertGenericResponseBoolean>>;
    async operationPutUpdateFirstAccess(idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Promise<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationPutUpdateFirstAccess.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPutUpdateFirstAccess.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return await this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/UpdateFirstAccess`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     *
     *
     * @param idOperation
     * @param opMetadata
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPutValidateFormDocument(idOperation: string, opMetadata: Array<MetadataOperation>, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationPutValidateFormDocument(idOperation: string, opMetadata: Array<MetadataOperation>, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationPutValidateFormDocument(idOperation: string, opMetadata: Array<MetadataOperation>, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationPutValidateFormDocument(idOperation: string, opMetadata: Array<MetadataOperation>, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationPutValidateFormDocument.');
        }

        if (opMetadata === null || opMetadata === undefined) {
            throw new Error('Required parameter opMetadata was null or undefined when calling operationPutValidateFormDocument.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPutValidateFormDocument.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/ValidateFormDocument`,
            opMetadata,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOperation
     * @param message
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationSendInternalMessage(idOperation: string, message: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationSendInternalMessage(idOperation: string, message: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationSendInternalMessage(idOperation: string, message: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationSendInternalMessage(idOperation: string, message: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationSendInternalMessage.');
        }

        if (message === null || message === undefined) {
            throw new Error('Required parameter message was null or undefined when calling operationSendInternalMessage.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationSendInternalMessage.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (message !== undefined && message !== null) {
            queryParameters = queryParameters.set('message', <any>message);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/SendInternalMessage`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param authorization The authorization token
     * @param idOperation
     * @param externalIdOperation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationAuthPreference(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListAuthPreference>;
    public operationGetOperationAuthPreference(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListAuthPreference>>;
    public operationGetOperationAuthPreference(authorization: string, idOperation?: string, externalIdOperation?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListAuthPreference>>;
    public operationGetOperationAuthPreference(authorization: string, idOperation?: string, externalIdOperation?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationAuthPreference.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (externalIdOperation !== undefined && externalIdOperation !== null) {
            queryParameters = queryParameters.set('externalIdOperation', <any>externalIdOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListAuthPreference>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationAuthPreference`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOperation
     * @param appId
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetAuthOperationOTP(idOperation: string, appId: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public operationGetAuthOperationOTP(idOperation: string, appId: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public operationGetAuthOperationOTP(idOperation: string, appId: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public operationGetAuthOperationOTP(idOperation: string, appId: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetAuthOperationOTP.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling operationGetAuthOperationOTP.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetAuthOperationOTP.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/Operation/AuthOperationOTP`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get parameters to configure widget text
     *
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetOperationParamsTextWidgets(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListWidgetParams>;
    public operationGetOperationParamsTextWidgets(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListWidgetParams>>;
    public operationGetOperationParamsTextWidgets(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListWidgetParams>>;
    public operationGetOperationParamsTextWidgets(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetOperationParamsTextWidgets.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseListWidgetParams>(`${this.basePath}/api/${this.apiVersion}/Operation/OperationParamsTextWidgetss`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Active operation STOPPER
     *
     * @param authorization The authorization token
     * @param idOperation
     * @param externalIdOperation
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPutActiveOperationStopper(authorization: string, idOperation?: string, externalIdOperation?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationPutActiveOperationStopper(authorization: string, idOperation?: string, externalIdOperation?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationPutActiveOperationStopper(authorization: string, idOperation?: string, externalIdOperation?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationPutActiveOperationStopper(authorization: string, idOperation?: string, externalIdOperation?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPutActiveOperationStopper.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (externalIdOperation !== undefined && externalIdOperation !== null) {
            queryParameters = queryParameters.set('externalIdOperation', <any>externalIdOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/ActiveOperationStopper`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetReprocessSIGAUT(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationGetReprocessSIGAUT(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationGetReprocessSIGAUT(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationGetReprocessSIGAUT(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling operationGetReprocessSIGAUT.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetReprocessSIGAUT.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetReprocessSIGAUT.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/ReprocessSIGAUT`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idCircuit
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationGetReprocessSIGORGA(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationGetReprocessSIGORGA(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationGetReprocessSIGORGA(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationGetReprocessSIGORGA(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idCircuit === null || idCircuit === undefined) {
            throw new Error('Required parameter idCircuit was null or undefined when calling operationGetReprocessSIGORGA.');
        }

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetReprocessSIGORGA.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetReprocessSIGORGA.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idCircuit !== undefined && idCircuit !== null) {
            queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/ReprocessSIGORGA`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
    *
    *
    * @param idOperation
    * @param appId
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public operationGetForwardingOTP(idOperation: string, appId: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public operationGetForwardingOTP(idOperation: string, appId: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public operationGetForwardingOTP(idOperation: string, appId: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public operationGetForwardingOTP(idOperation: string, appId: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetForwardingOTP.');
        }

        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling operationGetForwardingOTP.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetForwardingOTP.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (appId !== undefined && appId !== null) {
            queryParameters = queryParameters.set('appId', <any>appId);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/Operation/ForwardingOTP`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param idOperation
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public operationPostOperationSignQR(idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationPostOperationSignQR(idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationPostOperationSignQR(idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationPostOperationSignQR(idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationPostOperationSignQR.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationPostOperationSignQR.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/PostOperationSignQR`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    * Validate OTP Code
    *
    * @param idOperation
    * @param otpUser
    * @param authorization The authorization token
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public operationGetValidateOTPCode(idOperation: string, otpUser: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
    public operationGetValidateOTPCode(idOperation: string, otpUser: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
    public operationGetValidateOTPCode(idOperation: string, otpUser: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
    public operationGetValidateOTPCode(idOperation: string, otpUser: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (idOperation === null || idOperation === undefined) {
            throw new Error('Required parameter idOperation was null or undefined when calling operationGetValidateOTPCode.');
        }

        if (otpUser === null || otpUser === undefined) {
            throw new Error('Required parameter otpUser was null or undefined when calling operationGetValidateOTPCode.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling operationGetValidateOTPCode.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }
        if (otpUser !== undefined && otpUser !== null) {
            queryParameters = queryParameters.set('otpUser', <any>otpUser);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Operation/ValidateOTPCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
